import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ShieldAlert, LogOut } from 'lucide-react';

export const AccessDenied: React.FC = () => {
  const { attemptedEmail, error, logout } = useAuth();

  const getErrorMessage = () => {
    switch (error) {
      case 'domain_not_allowed':
        return {
          title: 'Domain Not Allowed',
          message: 'Your email domain is not authorized to access this application. Please use an approved company email address.',
        };
      case 'not_invited':
        return {
          title: 'Invitation Required',
          message: 'This application is currently invite-only. Please contact an administrator to request access.',
        };
      case 'inactive':
        return {
          title: 'Account Inactive',
          message: 'Your account is inactive. Please contact an administrator if you need access restored.',
        };
      case 'onboarding':
        return {
          title: 'Onboarding In Progress',
          message: 'Your account is still being onboarded. Please contact an administrator if you need access enabled.',
        };
      case 'offboarding':
        return {
          title: 'Offboarding In Progress',
          message: 'Your account is currently in offboarding and is no longer available for normal access.',
        };
      default:
        return {
          title: 'Access Denied',
          message: error || 'You do not have permission to access this application.',
        };
    }
  };

  const { title, message } = getErrorMessage();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="rounded-full bg-red-100 p-3">
            <ShieldAlert className="h-12 w-12 text-red-600" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {title}
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600 max-w">
          {message}
        </p>
        {attemptedEmail && (
          <p className="mt-4 text-center text-xs text-gray-500">
            Attempted login as: <span className="font-medium text-gray-700">{attemptedEmail}</span>
          </p>
        )}
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <button
            onClick={logout}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <LogOut className="h-5 w-5 mr-2" />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};
